import React from "react";
import { withStyles } from "@material-ui/core/styles";
import { Paper } from "@material-ui/core";
const styles = (theme) => ({
  outerMostWrapperActual: {
    zIndex: 2,
    position: "absolute",
    pointerEvents: "auto",
    display: "flex",
    flexDirection: "column",
    backgroundColor: theme.ModalBGColor,
    top: 80,
    right: "2%",
    padding: "5px",
  },
  outerMostWrapperPlanned: {
    zIndex: 2,
    position: "absolute",
    pointerEvents: "auto",
    display: "flex",
    flexDirection: "column",
    backgroundColor: theme.ModalBGColor,
    top: 30,
    right: "2%",
    padding: "5px",
  },
  actualRouteHeader: {
    fontWeight: "bold",
    fontSize: "10px",
    lineHeight: "14px",
    textAlign: "center",
  },
  plannedRouteHeader: {
    fontWeight: "bold",
    fontSize: "10px",
    lineHeight: "14px",
    textAlign: "center",
    color: theme.ToggleIconColor,
  },
  routeDetail: {
    fontSize: "9px",
    lineHeight: "12px",
    textAlign: "center",
    color: theme.iconColor,
    paddingTop: "5px",
  },
});
const RouteLegend = ({ classes, header, label, type }) => {
  return (
    <Paper
      className={
        type === "Actual"
          ? classes.outerMostWrapperActual
          : classes.outerMostWrapperPlanned
      }
    >
      <div
        className={
          type === "Actual"
            ? classes.actualRouteHeader
            : classes.plannedRouteHeader
        }
      >
        {header}
      </div>
      <div className={classes.routeDetail}>{label}</div>
    </Paper>
  );
};

export default withStyles(styles)(RouteLegend);
